import React, { FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

import styled, { useTheme } from 'styled-components/native'

import {
  CALENDAR_LANDING_PAGE_SUPPORT_LINK_DA,
  CALENDAR_LANDING_PAGE_SUPPORT_LINK_OUS,
  CALENDAR_SUPPORT_TICKET_LINK_DA,
  CALENDAR_SUPPORT_TICKET_LINK_OUS,
} from '@lyrahealth-inc/shared-app-logic/src/features/calendar/provider/constants'
import { BodyText } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/bodyText/BodyText'
import { Link } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/link/Link'
import { ProviderCalendarLandingContent } from '@lyrahealth-inc/ui-core-crossplatform/src/organisms/providerCalendarLandingContent/ProviderCalendarLandingContent'
import { BodyTextSize } from '@lyrahealth-inc/ui-core-crossplatform/src/styles/typeStyles'
import { ThemeType } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/themes/ThemeProvider'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

import CalendarSetupCard from './CalendarSetupCard'
import { getAuthConfig } from '../data/auth/authSelectors'

const SetupCard = styled(CalendarSetupCard)(({ theme }) => ({
  paddingTop: theme.spacing['32px'],
}))

const OuterContainer = styled.View(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  backgroundColor: theme.colors.backgroundSecondary,
}))

const DescriptionContainer = styled.View<{ theme: ThemeType }>(({ theme }) => ({
  marginTop: theme.spacing['56px'],
}))

export const CalendarLandingPage: FunctionComponent = () => {
  const { colors } = useTheme() as ThemeType
  const config = useSelector(getAuthConfig)

  return (
    <OuterContainer>
      <SetupCard />
      <ProviderCalendarLandingContent />
      <DescriptionContainer>
        <BodyText
          color={colors.textSecondary}
          text={
            <FormattedMessage
              defaultMessage='For more information about how to connect your calendar <supportLink>click here</supportLink>. Still need help? Submit a ticket <ticketLink>here</ticketLink>. We’ll get back to you soon.'
              description='Text offer providers information about connecting their calendar as well as support if they need more help'
              values={{
                supportLink: (text: string) => (
                  <Link
                    testID={tID('CalendarLandingPage-support-link')}
                    text={text}
                    //TODO: Will eventually need Mixpanel event: DACN-1336
                    onPress={() =>
                      window.open(
                        config?.inProductCalendar?.useInternationalLinks
                          ? CALENDAR_LANDING_PAGE_SUPPORT_LINK_OUS
                          : CALENDAR_LANDING_PAGE_SUPPORT_LINK_DA,
                        '_blank',
                      )
                    }
                    size={BodyTextSize.DEFAULT}
                    underline
                  />
                ),
                ticketLink: (text: string) => (
                  <Link
                    testID={tID('CalendarLandingPage-ticket-link')}
                    text={text}
                    //TODO: Will eventually need Mixpanel event: DACN-1336
                    onPress={() =>
                      window.open(
                        config?.inProductCalendar?.useInternationalLinks
                          ? CALENDAR_SUPPORT_TICKET_LINK_OUS
                          : CALENDAR_SUPPORT_TICKET_LINK_DA,
                        '_blank',
                      )
                    }
                    size={BodyTextSize.DEFAULT}
                    underline
                  />
                ),
              }}
            />
          }
        />
      </DescriptionContainer>
    </OuterContainer>
  )
}
